import './Hymn.css.proxy.js';
/* src/components/Hymn.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	attr,
	children,
	claim_component,
	claim_element,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_style,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { IconType } from "./data/icons.js";
import { onMount } from "../../web_modules/svelte.js";
import { getHymns } from "./data/getHymns.js";
import ProgramItem from "./ProgramItem.js";

function create_fragment(ctx) {
	let div;
	let programitem;
	let current;

	programitem = new ProgramItem({
			props: {
				title: /*title*/ ctx[0],
				content: "<a href=" + /*webLink*/ ctx[2] + ">" + /*hymnTitle*/ ctx[1] + "</a>",
				bg: false,
				icon: IconType.hymn
			}
		});

	return {
		c() {
			div = element("div");
			create_component(programitem.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, style: true });
			var div_nodes = children(div);
			claim_component(programitem.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "hover svelte-14gug5f");
			set_style(div, "display", /*hymnTitle*/ ctx[1] ? "block" : "none");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(programitem, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const programitem_changes = {};
			if (dirty & /*title*/ 1) programitem_changes.title = /*title*/ ctx[0];
			if (dirty & /*webLink, hymnTitle*/ 6) programitem_changes.content = "<a href=" + /*webLink*/ ctx[2] + ">" + /*hymnTitle*/ ctx[1] + "</a>";
			programitem.$set(programitem_changes);

			if (!current || dirty & /*hymnTitle*/ 2) {
				set_style(div, "display", /*hymnTitle*/ ctx[1] ? "block" : "none");
			}
		},
		i(local) {
			if (current) return;
			transition_in(programitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(programitem);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	var _a, _b;
	let { title } = $$props, { number } = $$props;
	let hymnTitle;
	let webLink;
	const hymns = getHymns();

	hymnTitle = (_a = hymns[number - 1]) === null || _a === void 0
	? void 0
	: _a.title;

	webLink = (_b = hymns[number - 1]) === null || _b === void 0
	? void 0
	: _b.url;

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("number" in $$props) $$invalidate(3, number = $$props.number);
	};

	return [title, hymnTitle, webLink, number];
}

class Hymn extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, number: 3 });
	}
}

export default Hymn;
//# sourceMappingURL=Hymn.js.map
